import React from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';

import { ICustomFieldsDTO } from '../../../../../../../../api/custom-fields.dao';
import { OEToggle } from '../../../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../../../global/text/text';

interface IProps {
    field: ICustomFieldsDTO;
    intl: IntlShape;
    toggleVisibility: (id: number, field: ICustomFieldsDTO) => void;
}

export const CustomFieldHidden = injectIntl(mobxReact.observer((props: IProps): JSX.Element => {
    const { toggleVisibility, field } = props;
    const { externalFieldId, defaultFieldTitle, defaultFieldId, customFieldId } = field;
    const title = externalFieldId ?? defaultFieldTitle;
    const id = defaultFieldId ?? customFieldId;

    return (
        <div className='custom-field__hidden'>
            <OEToggle isSelected={false} onClick={() => toggleVisibility(id, field)}/>
            <span className='website-custom__disabled'>
                <Text message={`${title} field is hidden`}/>
            </span>
        </div>
    );
}));
